import React from 'react';
import { excerpt } from '../../../helpers/text/excerpt';
import useStyle from './card.style';

export interface CardHeaderProps {
  title: string;
  subTitle?: string;
}
const CardHeader = ({ title, subTitle }: CardHeaderProps) => {
  const classes = useStyle();
  return (
    <div className={classes.header}>
      <h3>{excerpt(title, 28)}</h3>
      {subTitle && <p>{excerpt(subTitle, 100)}</p>}
    </div>
  );
};

export default CardHeader;
